import React, {useState} from 'react';
import {Form, Formik} from 'formik';
import * as yup from 'yup';
import Box from '@material-ui/core/Box/Box';
import Button from '@material-ui/core/Button';
import {useDispatch} from 'react-redux';
import Cron from 'react-cron-generator';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';

import {InputTextField} from '../../../@crema/components/InputTextField';
import {savePriceIncrease} from '../../../redux/actions/PriceIncrease';

interface IIncreasePriceFormFields {
  percentage: number;
}

interface IncreasePriceFormProps {
  initialCronValue: string;
  initialPercentage: number;
  disabledForm: boolean;
}

const validationSchema = yup.object({
  percentage: yup.number().min(0).max(100).required(),
});

export const IncreasePriceForm: React.FC<IncreasePriceFormProps> = ({
  initialCronValue,
  initialPercentage,
  disabledForm,
}): React.ReactElement => {
  const dispatch = useDispatch();
  const [cronValue, setCronValue] = useState<string>(initialCronValue);

const onSubmit = (data: IIncreasePriceFormFields): void => {
  const parts = cronValue.split(' ');
  
  const cleanParts = parts.slice(0, 6);

  const dayMap: any = { 'MON': 1, 'TUE': 2, 'WED': 3, 'THU': 4, 'FRI': 5, 'SAT': 6, 'SUN': 0 };
  
  let dow = cleanParts[5];
  
  Object.keys(dayMap).forEach(day => {
    dow = dow.split(day).join(dayMap[day]);
  });
  
  if (dow.includes(',')) {
    const sortedDays = dow
      .split(',') 
      .map(Number) 
      .sort((a, b) => a - b);
      
    const compressed: string[] = [];
    let start = sortedDays[0];
    let end = sortedDays[0];

    for (let i = 1; i < sortedDays.length; i++) {
        if (sortedDays[i] === end + 1) {
            end = sortedDays[i];
        } else {
            compressed.push(start === end ? start.toString() : `${start}-${end}`);
            start = sortedDays[i];
            end = sortedDays[i];
        }
    }
    compressed.push(start === end ? start.toString() : `${start}-${end}`);
    
    dow = compressed.join(',');
    
    if (dow === '0-6') {
      dow = '*';
    }
  }

  cleanParts[5] = dow;


  const cron = cleanParts.join(' ').replace(/\?/g, '*');

  dispatch(savePriceIncrease(cron, data.percentage / 100));
};

  const handleCronInputsFocus = (event: React.FocusEvent<HTMLDivElement>) => {
    const target = event.target as HTMLInputElement;
    
    if (target && target.tagName === 'INPUT') {
      if (target.type === 'number' || target.type === 'text') {
        target.select();
      }
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          percentage: initialPercentage * 100,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}>
        {(): React.ReactElement => (
          <Box textAlign='left' mt={8} clone>
              <Form>
                <Box 
                flexGrow={1} 
                style={{ width: '100%', 
                minWidth: '400px' }} 
                className="cron-container-wrapper"
                onFocus={handleCronInputsFocus}
                >
                  <Cron
                    onChange={(e): void => setCronValue(e)}
                    showResultText={true}
                    value={cronValue}
                  />
                </Box>

                <Box display='flex'>
                  <Box display='flex' flexGrow={1} mr={10} onFocus={handleCronInputsFocus}>
                    <InputTextField
                      type='number'
                      placeholder='Enter percentage'
                      name='percentage'
                      inputProps={{'aria-label': 'naked'}}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>%</InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Box display='flex' justifyContent='flex-end'>
                    <Button
                      variant='contained'
                      color='primary'
                      disabled={disabledForm}
                      type='submit'>
                      Save
                    </Button>
                  </Box>
                </Box>
              </Form>
          </Box>
        )}
      </Formik>
    </>
  );
};
